import { PencilIcon } from "lucide-react";
import { useContext } from "react";
import { CheckIcon } from "@heroicons/react/outline";

import { DatasetEditorContext } from "..";

import { Button } from "@/components/ui/button";
import { useRbac } from "@/providers/RbacProvider";
import { EntityType } from "@/queries";
import { BasicTooltip } from "@/components/ui/Tooltip";

const EditButton = () => {
  const context = useContext(DatasetEditorContext);

  const { isEditDisabled } = useRbac();
  const cannotEditDataset = isEditDisabled(EntityType.DATASET);

  return (
    <BasicTooltip
      content={
        context?.isDraft
          ? "You don't have permission to save this dataset"
          : "You don't have permission to edit this dataset"
      }
      shouldShow={cannotEditDataset}
    >
      <span>
        {context?.isDraft ? (
          <Button
            disabled={
              cannotEditDataset ||
              context?.rows?.length === 0 ||
              context?.isSavingCell ||
              context?.processingType === "upload" ||
              context?.processingType === "deleteRows"
            }
            isLoading={context?.isSavingDataset}
            onClick={() => context?.handleSaveAsNewVersionClick()}
            size="sm"
          >
            <CheckIcon className="h-4 w-auto pr-1" />
            Save Dataset
          </Button>
        ) : (
          <Button
            className="inline-flex items-center"
            isLoading={
              context?.isSettingDraftDatasetStateFromDataset ||
              context?.processingType === "newVersion"
            }
            disabled={
              cannotEditDataset ||
              context?.isSavingCell ||
              context?.processingType === "newVersion" ||
              context?.processingType === "deleteRows"
            }
            onClick={context?.handleEditClick}
            size="sm"
            variant="outline"
          >
            <PencilIcon aria-hidden="true" className="h-4 w-auto pr-1" />
            New Version
          </Button>
        )}
      </span>
    </BasicTooltip>
  );
};

export default EditButton;
